
import Swal from "sweetalert2";
import HelperMixin from '../../../Shared/HelperMixin.vue';
import PaginationHelper from '../../../Shared/PaginationHelper.vue';
export default {
    name: 'Subscriptions',
    mixins: [HelperMixin],
    components: {
        PaginationHelper
    },

    async created() {
        await this.CheckLoginStatus();
        await this.GetAllVehicles();
        await this.GetAllServices();
        await this.GetAllItems();

        if (this.loginDetails) {
            if (this.loginDetails.userType != 1 && this.loginDetails.userType != 20 && this.loginDetails.userType != 40)
                this.logout();
        }

        this.GetInfo();
    },

    computed: {
        totalPages() {
            return Math.ceil(this.pages / this.pageSize);
        }
    },

    data() {
        return {



            pageNo: 1,
            pageSize: 10,
            pages: 0,
            state: 0,
            Search: '',

            ScreenTitle: ' الصيانة  ',
            ScreenTitleSingle: ' طلب   ',
            ScreenTitleSingleAl: 'الطلب  ',

            Info: [],
            Statistics: [],
            InvoicesItems: [],

            AddDialog: false,

            SelectedItem: '',

            ruleForm: {
                Id: '',
                InvoicesId: '',
                ServicesId: '',
                ItemsId: '',
                Quntity: '',
                Price: '',
            },
            rules: {
                ServicesId: this.$helper.Required(),
            },

        };
    },



    methods: {

        GetInfo(pageNo) {
            this.pageNo = pageNo;
            if (this.pageNo === undefined) {
                this.pageNo = 1;
            }

            if (!this.Search)
                this.$blockUI.Start();


            this.$http.GetInvoices(this.pageNo, this.pageSize, this.Search)
                .then(response => {
                    if (!this.Search)
                        this.$blockUI.Stop();

                    this.Info = response.data.info;
                    this.pages = response.data.count;
                })
                .catch(() => {
                    if (!this.Search)
                        this.$blockUI.Stop();
                    this.pages = 0;
                });
        },

        OpenInvoicesItems(item) {
            this.SelectedItem = item;
            this.ClearForm(this.ruleForm);
            this.GetInvoicesItems();

        },


        OpenPrint(item) {
            this.SelectedItem = item;
            this.ClearForm(this.ruleForm);
            this.GetInvoicesItemsToPrint();

        },


        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.ruleForm.Id = Number(0);
                    if (!this.ruleForm.Quntity) {
                        this.ruleForm.Quntity = Number(0);
                    } else {
                        this.ruleForm.Quntity = Number(this.ruleForm.Quntity);
                    }
                        

                    if (!this.ruleForm.Price) {
                        this.ruleForm.Price = Number(0);
                    } else {
                        this.ruleForm.Price = Number(this.ruleForm.Price);
                    }
                        

                    if (!this.ruleForm.ItemsId)
                        this.ruleForm.ItemsId = Number(0);

                    this.ruleForm.InvoicesId = this.SelectedItem.id;


                    this.$blockUI.Start();
                    this.$http.AddInvoicesItems(this.ruleForm)
                        .then(response => {
                            this.$blockUI.Stop();
                            this.GetInfo();
                            this.GetInvoicesItems();

                            this.ClearForm(this.ruleForm);
                            this.$helper.DestroyElemntById('Close');
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الإضافة', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الإضافة', 'حدت خطأ غير متوقع');
                            }
                        });


                } else {
                    this.$helper.showSwal('warning');
                    return false;
                }
            });
        },

        GetInvoicesItems() {
            this.$blockUI.Start();
            this.$http.GetInvoicesItems(this.SelectedItem.id)
                .then(response => {
                    this.$blockUI.Stop();
                    this.InvoicesItems = response.data.info;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });
        },

        GetInvoicesItemsToPrint() {
            this.$blockUI.Start();
            this.$http.GetInvoicesItems(this.SelectedItem.id)
                .then(response => {
                    this.$blockUI.Stop();
                    this.InvoicesItems = response.data.info;
                    this.PrintInvoice(response.data.info)
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });
    },



        PrintInvoice(item) {
            try {

                let total = 0;
                let count = 0;


                let tableRows = '';
                item.forEach(el => {
                    count += 1;
                    total += el.total;
                    tableRows += `
                    <tr>
                        <td>${el.services}</td>
                        <td>${el.items}</td>
                        <td>${el.quntity}</td>
                        <td>${this.formatNumber(el.price)}</td>
                        <td>${this.formatNumber(el.total)}</td>
                    </tr>
                    `
                })

                let reportHTML = `
                    <!DOCTYPE html>
<html lang="ar" dir="rtl">

<head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <meta http-equiv="X-UA-Compatible" content="ie=edge" />

    <title>فاتورة</title>

    <link href="https://fonts.googleapis.com/css2?family=Cairo:wght@400;500;600;700&display=swap" rel="stylesheet">

    <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css" rel="stylesheet"
        integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC" crossorigin="anonymous" />


</head>

<body>

    <div class="main-container">
        <div class="page-container">
            <div class="page-inner">

                <div class="Header" style="height: 230px;">
                    <div class="d-flex justify-content-between">
                        <p class="fs-6">
                            <img src="data:image/png;base64,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"
                                width="60" style="margin-top: -9px" />
                            شركة رواسي الصحراء
                            </br>
                        </p>
                        <p class="fs-6 fw-bolder">

                        </p>
                        <p class="fs-6">${this.GetTodayDate()}</p>
                    </div>
                    <div class="d-flex justify-content-center ">
                        <p class="fs-6 fw-bolder" style="margin-top: -15;">
                             فاتورة مبيعات رقم : ${this.SelectedItem.code}


                        </p>

                    </div>
                    <div class="row gx-5">
                        <div class="col-6">
                            <table class="table table-sm">
                                <tbody>
                                    <tr class="text-right bg-gray-striped-2">
                                        <th colspan="2" width="20%" > بيانات العميل </th>
                                    </tr>
                                    <tr class="text-right bg-gray-striped-2">
                                        <th  style="border-left: 1px solid lightgray;"> إسم العميل  </th>
                                        <td>   ${this.SelectedItem.name} </td>
                                    </tr>
                                    <tr class="text-right bg-gray-striped-2">
                                        <th  style="border-left: 1px solid lightgray;"> رقم الهاتف </th>
                                        <td> ${this.SelectedItem.phone}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col-6">
                            <table class="table table-sm">
                                <tbody>
                                    <tr class="text-right bg-gray-striped-2">
                                        <th colspan="2" width="20%" >بيانات المركبة    </th>
                                    </tr>
                                    <tr class="text-right bg-gray-striped-2">
                                        <th  style="border-left: 1px solid lightgray;">نوع المركبة     </th>
                                        <td>  ${this.SelectedItem.manufacturers} /  ${this.SelectedItem.vehiclesModels} </td>
                                    </tr>
                                    <tr class="text-right bg-gray-striped-2">
                                        <th  style="border-left: 1px solid lightgray;">  رقم الهيكل   </th>
                                        <td> ${this.SelectedItem.vin}    </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>

                <div class="content" style="height: 720px;">
                    <table class="table table-sm table-bordered text-center border border-dark align-middle mt-2">
                        <thead>
                            <tr class="bg-gray">

                                <th width="100"> الخدمة</th>
                                <th>  الصنف</th>
                                <th>الكمية</th>
                                <th>التكلفة</th>
                                <th>الإجمالي</th>
                            </tr>
                        </thead>
                        <tbody>
                         ${tableRows}
                        </tbody>
                    </table>

                    <div class="row text-lelft">
                        <hr />
                        <div class="col" style="display: flex;justify-content: end;">
                            <p style="margin-left: 10px;">
                                عدد الأصناف :
                                <b> ${count}  </b>
                            </p>
                            <p>
                                اجمالي الفاتورة :
                                <b> ${this.formatNumber(total)} </b>

                            </p>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    </div>


</body>



<style>
    body {
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
        background-color: #fafafa;
        color: #414142;
        font: 10px "Cairo", sans-serif;
        -webkit-print-color-adjust: exact !important;
    }

    * {
        box-sizing: border-box;
        -moz-box-sizing: border-box;
    }

    .page-container {
        width: 210mm;
        min-height: 297mm;
        padding: 0mm;
        margin: 10mm auto;
        border: 1px #d3d3d3 solid;
        border-radius: 5px;
        background: white;
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
    }

    .page-inner {
        padding: 0;
        height: 297mm;
        padding: 10mm;
    }

    /* .page-inner table,
.page-inner td,
.page-inner th {
  padding: 2mm;
  border-collapse: collapse;
  border: 1px solid #414142;
} */

    @page {
        size: A4;
        margin: 0;
    }

    @media print {

        html,
        body {
            width: 210mm;
            height: 297mm;
        }

        .page-container {
            margin: 0;
            border: initial;
            border-radius: initial;
            width: initial;
            min-height: initial;
            box-shadow: initial;
            background: initial;
            page-break-after: always;
        }
    }

    .controls-container {
        color: #414142;
        background: #f1f1f2;
        padding: 5px;
        border: 1px solid #d1d3d4;
        border-radius: 2px;
        position: fixed;
        top: 50px;
        left: 10px;
        font-size: 12px;
    }

    .controls-container button {
        background-color: #333333;
        border: none;
        color: white;
        padding: 15px 32px;
        text-align: center;
        text-decoration: none;
        display: block;
        width: 100%;
        margin-bottom: 5px;
        outline: none;
        cursor: pointer;
        transition: 0.3s;
    }

    .controls-container button:hover {
        background-color: #4caf50;
    }

    @media print {
        .controls-container {
            display: none !important;
        }
    }

    th,
    td {
        line-height: 10px;
    }

    .bg-gray {
        background-color: #c0c0c0 !important;
    }

    .bg-gray-striped-1 {
        background-color: #e1e1e1 !important;
    }

    .bg-gray-striped-2 {
        background-color: #ededed !important;
    }
</style>


</html>


            











        `;
                const WinPrint = window.open();
                let is_chrome = Boolean(WinPrint.chrome);
                WinPrint.document.write(reportHTML);
                if (is_chrome) {
                    setTimeout(function () {
                        WinPrint.document.close();
                        WinPrint.focus();
                        WinPrint.print();
                    }, 1000);
                } else {
                    WinPrint.document.close();
                    WinPrint.focus();
                }
            } catch (error) {
                this.$blockUI.Stop();
                this.$notify({
                    title: "خطأ",
                    message: "يوجد خطاء في الطباعة",
                    position: "bottom-right",
                    type: "error",
                });
            }
        },

        DeleteInvoicesItems(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من عملية الحذف  ؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.DeleteInvoicesItems(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo();
                            this.GetInvoicesItems();
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', 'حدت خطأ غير متوقع');
                            }
                        });
                    return;
                }
            });
        },

        Delete(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من عملية الحذف  ؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.DeleteRequest(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo();
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', 'حدت خطأ غير متوقع');
                            }
                        });
                    return;
                }
            });
        },

        Start(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من تغير حالة المركبة إلي البدء في العمل    ؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.Start(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo();
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية القبول', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية القبول', 'حدت خطأ غير متوقع');
                            }
                        });
                    return;
                }
            });
        },


        Ready(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من تغير حالة المركبة إلي جاهزة للاستلام    ؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.Ready(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo();
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية القبول', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية القبول', 'حدت خطأ غير متوقع');
                            }
                        });
                    return;
                }
            });
        },


        Delivered(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من تغير حالة المركبة إلي مستلمة    ؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.Delivered(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo();
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية القبول', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية القبول', 'حدت خطأ غير متوقع');
                            }
                        });
                    return;
                }
            });
        },


        //Support Info
        Back() {
            this.state = 0;
            this.ClearForm(this.ruleForm);
            this.SelectedItem = '';
            this.GetInfo(this.pageNo);
        },


    }
}
